(function() {
	'use strict';
	angular.module('app.dashboard')
		.service('deliveryPerformanceTypeService', deliveryPerformanceTypeService);

	deliveryPerformanceTypeService.$inject = ['$http', 'URLS'];
	function deliveryPerformanceTypeService($http, URLS) {
		var types = {};
		var loaded = false;
		return {
			getTypes: getTypes,
			loadTypes: loadTypes,
			isLoaded: isLoaded
		};

		function isLoaded() {
			return loaded;
		}

		function getTypes() {
			return types;
		}

		function loadTypes() {
			return $http.get(URLS.host + URLS.prefix + 'LDNA_A_S/FactoryControlVariables/SupplierDeliveryPerformanceCalculationType')
				.then(loadTypesSuccess)
				.catch(loadTypesFailure);
			
			function loadTypesSuccess(response) {
				loaded = true;
				_.forEach(response.data, function(setting) {
					types[setting.factoryNdx] = setting.value;
				});
			}

			function loadTypesFailure(error) {
				types = {};
				loaded = false;
			}
		}
	}
})();
